var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v("\n  © "+_vm._s(_vm.showCopyrightText ? _vm.$t('Copyright') : '')+"\n  "+_vm._s(new Date().getFullYear())+" SermonAudio"+_vm._s(_vm.showPeriod ? '.' : '')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }